// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { PatientFinderRequestSearchResponse } from './patientFinderRequestSearchResponse.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PatientV1PatientV1PatientFinderRequestSearchDefaultResponse {
    'success': boolean;
    'messages': Array<string>;
    'data': PatientFinderRequestSearchResponse | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PatientV1PatientV1PatientFinderRequestSearchDefaultResponse>> = [
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
        {
            "name":     "data",
            "baseName": "data",
            "type":     "PatientFinderRequestSearchResponse"
        },
    ];

    static getAttributeTypeMap() {
        return PatientV1PatientV1PatientFinderRequestSearchDefaultResponse.attributeTypeMap;
    }
}
